import HhText from './hh-text';
export default HhText;
